import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/v1/auth/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/home/logout',
    method: 'post',
    data
  })
}

export function getInfo(params) {
  return request({
    url: '/api/v1/student/info/mine',
    method: 'get',
    params
  })
}

export function userRegister(data) {
  return request({
    url: '/api/v1/auth/register',
    method: 'post',
    data
  })
}

export function sendSmsCode(data) {
  return request({
    url: '/api/v1/sms/' + data.phone + '/register',
    method: 'get'
  })
}

export function findSmsCode(data) {
  return request({
    url: '/api/v1/sms/' + data.phone + '/forgot',
    method: 'get'
  })
}

export function userFindPassword(data) {
  return request({
    url: '/api/v1/auth/reset',
    method: 'post',
    data
  })
}

export function getCourseItemInfo(data) {
  return request({
    url: '/user/course/item/info',
    method: 'post',
    data
  })
}

export function getAddressList(params) {
  return request({
    url: '/api/v1/mall/student/address/list',
    method: 'get',
    params
  })
}

export function saveAddress(data) {
  return request({
    url: '/api/v1/mall/student/address/save',
    method: 'post',
    data
  })
}

export function upadteAddress(data) {
  return request({
    url: '/api/v1/mall/student/address/update',
    method: 'post',
    data
  })
}

export function deleteAddress(params) {
  return request({
    url: '/api/v1/mall/student/address/delete',
    method: 'get',
    params
  })
}

export function getAddressDetail(params) {
  return request({
    url: '/api/v1/mall/student/address/detail',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/student/index.js